export enum IdStatusPeticionamento {
    PendenteAprovacao = 1,
    Aprovado = 2,
    Reprovado = 3,
    SolicitadoProtocolo = 4,
    AguardandoProtocolo = 5,
    Protocolado = 6,
    ReprovadoEscritorio = 7,
}
